const initialState = {
  loading: false,
  communities: [],
  featuredCampaigns: [],
  pagination: {
    pageNumber: 1,
    pageSize: 9
  },
  filter: {
    name: ''
  },
  states: []
};

const communityListings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_FOR_COMMUNITY_LISTINGS':
    case 'FOLLOW_COMPANY_COMMUNITY_REQUEST':
    case 'FOLLOW_COMPANY_COMMUNITY_SUCCESS':
    case 'FOLLOW_COMPANY_COMMUNITY_FAILED':
    case 'SET_PAGINATION_FOR_COMMUNITY_LISTINGS':
    case 'GET_COMMUNITY_LISTINGS_REQUEST':
    case 'GET_COMMUNITY_LISTINGS_SUCCESS':
    case 'GET_COMMUNITY_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_REQUEST':
    case 'GET_STATES_LISTINGS_REQUEST':
    case 'GET_STATES_LISTINGS_SUCCESS':
    case 'GET_STATES_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_SUCCESS':
    case 'GET_FEATURED_CAMPAIGNS_FOR_COMMUNITY_LISTINGS_FAILED':
    case 'GET_PLEDGE_OF_THE_DAY_SUCCESS':
    case 'GET PLEDGE OF THE DAY':
    case 'GET_PLEDGE_OF_THE_DAY_FAILED': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default communityListings;
